import {
  DestinationType,
  DisplaySwitching,
  HoujinnType,
  ProcessType,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";

const headList = [
  { headTitle: "警告" },
  { headTitle: "出力日時" },
  { headTitle: "ファイル" },
  { headTitle: "出力指示者" },
];

const radioList = TkGetCodeList(ProcessType);

const destinationRadioList = TkGetCodeList(DestinationType);

const yearList = [
  { value: "2023", label: "2023年度" },
  { value: "2024", label: "2024年度" },
  { value: "2025", label: "2025年度" },
  { value: "2026", label: "2026年度" },
  { value: "2027", label: "2027年度" },
];

const houjinnRadioList = TkGetCodeList(HoujinnType);

const selectStaus = TkGetCodeList(DisplaySwitching);
// 年度末統計出力リスト
const yearOutput = [
  {
    value: "EXP1001001",
    label: "EXP1001001:退職手当金の請求及び支給決定等状況、月別",
    formKbn: "2",
  },
  {
    value: "EXP1001002",
    label: "EXP1001002:退職手当金の請求及び支給決定等状況",
    formKbn: "2",
  },
  {
    value: "EXP1001003",
    label: "EXP1001003:退職手当金の支給決定状況、退職年度・施設所在地別",
    formKbn: "2",
  },

  {
    value: "EXP1001004",
    label: "EXP1001004:退職手当金支給人員、退職理由・被共済職員期間別",
    formKbn: "2",
  },
  {
    value: "EXP1001005",
    label: "EXP1001005:退職手当金支給人員、退職年度・支給金額階級別",
    formKbn: "2",
  },
  {
    value: "EXP1001006",
    label: "EXP1001006:退職手当金の支給人員・金額、退職年度・退職理由別",
    formKbn: "2",
  },
  {
    value: "EXP1001007",
    label:
      "EXP1001007:加入状況・退職手当金の支給人員と金額・退職手当金の計算基礎額・単位掛金額",
    formKbn: "2",
  },
  {
    value: "EXP1001008",
    label: "EXP1001008:支給金額／施設種類別（施設事業単位）、在籍期間別",
    formKbn: "2",
  },
  {
    value: "EXP1001009",
    label: "EXP1001009:支給金額／都道府県別、平均加入期間",
    formKbn: "2",
  },
  {
    value: "EXP1001010",
    label: "EXP1001010:支給者／経営主体別（２区分）・被共済職員期間別",
    formKbn: "2",
  },
  {
    value: "EXP1001011",
    label: "EXP1001011:支給者／経営主体別（２区分）・支給金額階級別",
    formKbn: "2",
  },
  {
    value: "EXP1001012",
    label: "EXP1001012:支給者／都道府県別･被共済職員期間別・退職理由別",
    formKbn: "2",
  },
  {
    value: "EXP1001013",
    label: "EXP1001013:支給者／都道府県別・退職年度別",
    formKbn: "2",
  },
  {
    value: "EXP1001014",
    label:
      "EXP1001014:支給金額／経営主体別（２区分）・都道府県別・1 人当たりの支給金額",
    formKbn: "2",
  },
  {
    value: "EXP1001015",
    label:
      "EXP1001015:支給金額／都道府県別・施設種類別（法律単位）・退職年度別	",
    formKbn: "2",
  },
  {
    value: "EXP1001016",
    label:
      "EXP1001016:支給金額／都道府県別・施設種類別（負担単位）・総支給金額・1人当たりの支給金額",
    formKbn: "2",
  },
  {
    value: "EXP1001017",
    label:
      "EXP1001017:支給金額／施設種類別（施設・事業単位）・総支給金額・1人当たりの支給金額",
    formKbn: "2",
  },
  {
    value: "EXP1001018",
    label: "EXP1001018:被共済職員期間別支給状況表",
    formKbn: "2",
  },
  { value: "EXP1001020", label: "EXP1001020:退職手当金支給状況", formKbn: "2" },
  {
    value: "EXP1001021",
    label: "EXP1001021:都道府県別の共済契約者、施設、職員の一覧表ファイル",
    formKbn: "2",
  },
];

// 確定統計出力リスト
const definitiveStatisticalOutput = [
  {
    value: "EXP1002022",
    label:
      "EXP1002022:共済契約者数・社会福祉施設等数・被共済職員数、経営主体別・共済契約者住所地別",
    formKbn: "2",
  },
  {
    value: "EXP1002023",
    label:
      "EXP1002023:共済契約者数・申出施設等数・被共済職員数、共済契約者住所地別",
    formKbn: "2",
  },
  {
    value: "EXP1002024",
    label:
      "EXP1002024:共済契約者数・介護施設等数・被共済職員数、共済契約者住所地別",
    formKbn: "2",
  },
  {
    value: "EXP1002025",
    label:
      "EXP1002025:共済契約者数・社会福祉施設等数・被共済職員数、共済契約者住所地別",
    formKbn: "2",
  },
  {
    value: "EXP1002026",
    label:
      "EXP1002026:共済契約者数・社会福祉施設等数・被共済職員数の増減、施設所在地別",
    formKbn: "2",
  },
  {
    value: "EXP1002027",
    label: "EXP1002027:共済契約者数・申出施設等数・被共済職員数、施設所在地別",
    formKbn: "2",
  },
  {
    value: "EXP1002028",
    label: "EXP1002028:共済契約者数・介護施設等数・被共済職員数、施設所在地別",
    formKbn: "2",
  },
  {
    value: "EXP1002030",
    label: "EXP1002030:被共済職員数、年齢階級別",
    formKbn: "2",
  },
  {
    value: "EXP1002031",
    label: "EXP1002031:被共済職員数、被共済職員期間別",
    formKbn: "2",
  },
  {
    value: "EXP1002032",
    label: "EXP1002032:被共済職員数、本俸月額階級別",
    formKbn: "2",
  },
  {
    value: "EXP1002033",
    label:
      "EXP1002033:被共済職員数・退職者数・退職率、施設種類別（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002034",
    label:
      "EXP1002034:被共済職員数・退職者数・退職率、施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002035",
    label:
      "EXP1002035:被共済職員数・退職者数・退職率、施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002036",
    label: "EXP1002036:被共済職員数・退職者数、職種別",
    formKbn: "2",
  },
  {
    value: "EXP1002037",
    label: "EXP1002037:都道府県補助金の収納状況、施設種類・施設所在地別",
    formKbn: "2",
  },
  {
    value: "EXP1002038",
    label: "EXP1002038:掛金の徴収決定額、共済契約者住所地別",
    formKbn: "2",
  },
  {
    value: "EXP1002039",
    label:
      "EXP1002039:共済契約者数・社会福祉施設等数・被共済職員数、共済契約者住所地別（社会福祉施設等のみ経営）",
    formKbn: "2",
  },
  {
    value: "EXP1002040",
    label:
      "EXP1002040:共済契約者数・介護施設等数・被共済職員数、共済契約者住所地別（介護施設等のみ経営）",
    formKbn: "2",
  },
  {
    value: "EXP1002041",
    label:
      "EXP1002041:共済契約者数・施設等数・被共済職員数、共済契約者住所地別",
    formKbn: "2",
  },
  {
    value: "EXP1002042",
    label: "EXP1002042:契約者／都道府県別、経営主体別（１０区分）",
    formKbn: "2",
  },
  {
    value: "EXP1002043",
    label:
      "EXP1002043:前年度新規加入契約者・契約解除・新規加入施設・施設廃止／都道府県別",
    formKbn: "2",
  },
  {
    value: "EXP1002044",
    label:
      "EXP1002044:施設／都道府県別・経営主体別（９区分）・施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002045",
    label: "EXP1002045:施設／都道府県別・施設種類別（法律単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002046",
    label: "EXP1002046:施設／都道府県別・施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002047",
    label: "EXP1002047:前年度新規加入施設／施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002048",
    label: "EXP1002048:施設廃止／施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002049",
    label:
      "EXP1002049:前年度新規加入職員／経営主体別（２区分）・施設種類別（施設・事業単位）・職種別",
    formKbn: "2",
  },
  {
    value: "EXP1002050",
    label:
      "EXP1002050:前年度新規加入職員／経営主体別（２区分）・施設種類別（施設・事業単位）・年齢別",
    formKbn: "2",
  },
  {
    value: "EXP1002051",
    label:
      "EXP1002051:契約対象外施設等に異動中／経営主体別（２区分）・契約対象外施設等異動期間別・契約対象外施設等種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002052",
    label:
      "EXP1002052:契約対象外施設等への異動者／経営主体別（２区分）・契約対象外施設等種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002053",
    label:
      "EXP1002053:契約対象外施設等からの復帰者／在籍期間別・契約対象外施設等異動期間別",
    formKbn: "2",
  },
  {
    value: "EXP1002054",
    label:
      "EXP1002054:被共済職員／経営主体別（９区分）・都道府県別・施設種類別（法律単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002055",
    label: "EXP1002055:被共済職員／経営主体別（９区分）・都道府県別",
    formKbn: "2",
  },
  {
    value: "EXP1002056",
    label:
      "EXP1002056:被共済職員／経営主体別（９区分）・施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002057",
    label: "EXP1002057:被共済職員／経営主体別（２区分）・職種別・在籍期間別",
    formKbn: "2",
  },
  {
    value: "EXP1002058",
    label: "EXP1002058:被共済職員／経営主体別（２区分）・職種別・本俸階級別",
    formKbn: "2",
  },
  {
    value: "EXP1002059",
    label: "EXP1002059:被共済職員／経営主体別（２区分）・職種別・年齢別・性別",
    formKbn: "2",
  },
  {
    value: "EXP1002060",
    label: "EXP1002060:被共済職員／在籍期間別・本俸階級別",
    formKbn: "2",
  },
  {
    value: "EXP1002061",
    label: "EXP1002061:被共済職員／施設種類別（施設・事業単位）・年齢別",
    formKbn: "2",
  },
  {
    value: "EXP1002062",
    label:
      "EXP1002062:退職者／経営主体別（９区分）・施設種類別（施設・事業単位）・本俸階級別",
    formKbn: "2",
  },
  {
    value: "EXP1002063",
    label: "EXP1002063:被共済職員／施設種類別（施設・事業単位）・年齢別・性別",
    formKbn: "2",
  },
  {
    value: "EXP1002064",
    label: "EXP1002064:退職者／経営主体別（２区分）・職種別・在籍期間別",
    formKbn: "2",
  },
  {
    value: "EXP1002065",
    label: "EXP1002065:退職者／経営主体別（２区分）・職種別・年齢別",
    formKbn: "2",
  },
  {
    value: "EXP1002066",
    label: "EXP1002066:退職者／経営主体別（２区分）・在籍期間別・本俸階級別",
    formKbn: "2",
  },
  {
    value: "EXP1002067",
    label: "EXP1002067:退職者／経営主体別（２区分）・在籍期間別・年齢別",
    formKbn: "2",
  },
  {
    value: "EXP1002068",
    label: "EXP1002068:退職者／都道府県別・施設種類別（法律単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002069",
    label: "EXP1002069:退職者／退職年度別",
    formKbn: "2",
  },
  {
    value: "EXP1002071",
    label:
      "EXP1002071:被共済職員／都道府県別・施設種類別（施設・事業単位）（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002072",
    label:
      "EXP1002072:その他（支給金額）／経営主体別（２区分）・施設種類別（施設・事業単位）・総支給金額・１人当たりの支給金額",
    formKbn: "2",
  },
  {
    value: "EXP1002073",
    label:
      "EXP1002073:その他（支給金額）／都道府県別・施設種類別（負担単位）・総支給金額・１人当たりの支給金額",
    formKbn: "2",
  },
  {
    value: "EXP1002074",
    label: "EXP1002074:施設部分解除／施設種類別（施設・事業単位）・解除理由別",
    formKbn: "2",
  },
  {
    value: "EXP1002075",
    label:
      "EXP1002075:二枚看板事業施設数／経営主体別（2 区分）・都道府県別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002076",
    label:
      "EXP1002076:被共済職員／経営主体別（2区分）・都道府県別・施設種類別（施設・事業単位）（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002077",
    label: "EXP1002077:被共済職員／都道府県別・施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002078",
    label:
      "EXP1002078:被共済職員／経営主体別（2区分）・都道府県別・施設種類別（施設・事業単位）（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002079",
    label:
      "EXP1002079:被共済職員／経営主体別（2区分）・施設種類別（施設・事業単位）・職種別（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002080",
    label: "EXP1002080:被共済職員／施設種類別（施設・事業単位）・職種別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002081",
    label:
      "EXP1002081:被共済職員／経営主体別（2 区分）・職種別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002082",
    label:
      "EXP1002082:被共済職員／経営主体別（2区分）・施設種類別（施設・事業単位）・在籍期間別（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002083",
    label: "EXP1002083:被共済職員／施設種類別（施設・事業単位）・在籍期間別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002084",
    label:
      "EXP1002084:被共済職員／経営主体別（2 区分）・在籍期間別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002085",
    label:
      "EXP1002085:被共済職員／経営主体別（2区分）・施設種類別（施設・事業単位）・本俸階級別（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002086",
    label: "EXP1002086:被共済職員／施設種類別（施設・事業単位）・本俸階級別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002087",
    label:
      "EXP1002087:被共済職員／経営主体別（2 区分）・本俸階級別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002088",
    label:
      "EXP1002088:退職者／経営主体別（2区分）・施設種類別（施設・事業単位）・職種別（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002089",
    label: "EXP1002089:退職者／施設種類別（施設・事業単位）・職種別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002090",
    label:
      "EXP1002090:退職者／経営主体別（2区分）・施設種類別（施設・事業単位）・職種別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002091",
    label:
      "EXP1002091:退職者／経営主体別（2区分）・施設種類別（施設・事業単位）・在籍期間別（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002092",
    label: "EXP1002092:退職者／施設種類別（施設・事業単位）・在籍期間別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002093",
    label:
      "EXP1002093:退職者／経営主体別（2区分）・施設種類別（施設・事業単位）・在籍期間別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002094",
    label:
      "EXP1002094:退職者／経営主体別（2区分）・施設種類別（施設・事業単位）・年齢別・性別（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002095",
    label: "EXP1002095:退職者／施設種類別（施設・事業単位）・年齢別・性別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002096",
    label:
      "EXP1002096:退職者／経営主体別（2区分）・施設種類別（施設・事業単位）・年齢別・性別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002097",
    label:
      "EXP1002097:前年度新規加入職員／経営主体別（2区分）・都道府県別・施設種類別（施設・事業単位）（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002098",
    label:
      "EXP1002098:前年度新規加入職員／都道府県別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002099",
    label:
      "EXP1002099:前年度新規加入職員／経営主体別（2 区分）・都道府県別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002100",
    label:
      "EXP1002100:退職者／経営主体別（2区分）・都道府県別・施設種類別（施設・事業単位）（社会福祉施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002101",
    label: "EXP1002101:退職者／都道府県別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002102",
    label:
      "EXP1002102:退職者／経営主体別（2 区分）・都道府県別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002103",
    label: "EXP1002103:経過措置職員数／都道府県別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002104",
    label: "EXP1002104:経過措置職員数／都道府県別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002105",
    label: "EXP1002105:経過措置職員数／在籍期間別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002106",
    label: "EXP1002106:経過措置職員数／在籍期間別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002107",
    label:
      "EXP1002107:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002108",
    label: "EXP1002108:合算申出者／都道府県別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002109",
    label:
      "EXP1002109:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002110",
    label:
      "EXP1002110:合算申出者／経営主体別（2 区分）・在籍期間別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002111",
    label: "EXP1002111:合算申出者／在籍期間別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002112",
    label:
      "EXP1002112:合算申出者／経営主体別（2 区分）・在籍期間別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002113",
    label:
      "EXP1002113:合算申出加入者／経営主体別（2 区分）・都道府県別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002114",
    label: "EXP1002114:合算申出加入者／都道府県別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002115",
    label:
      "EXP1002115:合算申出加入者／経営主体別（2 区分）・都道府県別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002116",
    label:
      "EXP1002116:合算申出加入者／経営主体別（2 区分）・在籍期間別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002117",
    label: "EXP1002117:合算申出加入者／在籍期間別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002118",
    label:
      "EXP1002118:合算申出加入者／経営主体別（2 区分）・在籍期間別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002119",
    label:
      "EXP1002119:合算申出請求者／経営主体別（2 区分）・都道府県別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002120",
    label: "EXP1002120:合算申出請求者／都道府県別・施設種類別（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002121",
    label:
      "EXP1002121:合算申出請求者／経営主体別（2 区分）・都道府県別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002122",
    label:
      "EXP1002122:転換施設数／経営主体別（2 区分）・都道府県別・施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002123",
    label:
      "EXP1002123:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別／合算期限切",
    formKbn: "2",
  },
  {
    value: "EXP1002124",
    label:
      "EXP1002124:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別／合算期限内",
    formKbn: "2",
  },
  {
    value: "EXP1002125",
    label:
      "EXP1002125:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別／合算後請求時効",
    formKbn: "2",
  },
  {
    value: "EXP1002126",
    label:
      "EXP1002126:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別／合算申出（未処理含む）",
    formKbn: "2",
  },
  {
    value: "EXP1002127",
    label: "EXP1002127:合算申出者／都道府県別・施設種類別／合算期限切（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002128",
    label: "EXP1002128:合算申出者／都道府県別・施設種類別／合算期限内（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002129",
    label: "EXP1002129:合算申出者／都道府県別・施設種類別／合算後請求時効（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002130",
    label:
      "EXP1002130:合算申出者／都道府県別・施設種類別／合算申出（未処理含む）（申出施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002131",
    label:
      "EXP1002131:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別／合算期限切",
    formKbn: "2",
  },
  {
    value: "EXP1002132",
    label:
      "EXP1002132:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別／合算期限内",
    formKbn: "2",
  },
  {
    value: "EXP1002133",
    label:
      "EXP1002133:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別／合算後請求時効",
    formKbn: "2",
  },
  {
    value: "EXP1002134",
    label:
      "EXP1002134:合算申出者／経営主体別（2 区分）・都道府県別・施設種類別／合算申出（未処理含む）",
    formKbn: "2",
  },
  {
    value: "EXP1002135",
    label: "EXP1002135:平均本俸／施設別／在籍期間・男",
    formKbn: "2",
  },
  {
    value: "EXP1002136",
    label: "EXP1002136:平均本俸／施設別／在籍期間・女",
    formKbn: "2",
  },
  {
    value: "EXP1002137",
    label: "EXP1002137:平均本俸／施設別／在籍期間・全体",
    formKbn: "2",
  },
  {
    value: "EXP1002138",
    label: "EXP1002138:平均本俸／職種別／在籍期間・男",
    formKbn: "2",
  },
  {
    value: "EXP1002139",
    label: "EXP1002139:平均本俸／職種別／在籍期間・女",
    formKbn: "2",
  },
  {
    value: "EXP1002140",
    label: "EXP1002140:平均本俸／職種別／在籍期間・全体",
    formKbn: "2",
  },
  {
    value: "EXP1002141",
    label: "EXP1002141:平均本俸／施設別／年齢・男",
    formKbn: "2",
  },
  {
    value: "EXP1002142",
    label: "EXP1002142:平均本俸／施設別／年齢・女",
    formKbn: "2",
  },
  {
    value: "EXP1002143",
    label: "EXP1002143:平均本俸／施設別／年齢・全体",
    formKbn: "2",
  },
  {
    value: "EXP1002144",
    label: "EXP1002144:平均本俸／職種別／年齢・男",
    formKbn: "2",
  },
  {
    value: "EXP1002145",
    label: "EXP1002145:平均本俸／職種別／年齢・女",
    formKbn: "2",
  },
  {
    value: "EXP1002146",
    label: "EXP1002146:平均本俸／職種別／年齢・全体",
    formKbn: "2",
  },
  {
    value: "EXP1002147",
    label: "EXP1002147:契約者／システム利用の有無／都道府県別",
    formKbn: "2",
  },
  {
    value: "EXP1002148",
    label: "EXP1002148:契約者／システム利用の有無／施設数別",
    formKbn: "2",
  },
  {
    value: "EXP1002149",
    label: "EXP1002149:システム利用の有無／施設種類別",
    formKbn: "2",
  },
  {
    value: "EXP1002150",
    label:
      "EXP1002150:【補助】01.被共済職員数／施設種類別、年齢各歳別、在籍期間別",
    formKbn: "2",
  },
  {
    value: "EXP1002151",
    label:
      "EXP1002151:【補助】15.被共済職員／経営主体別（９区分）・施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002152",
    label:
      "EXP1002152:【補助】60.被共済職員／都道府県別・施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002153",
    label:
      "EXP1002153:【補助】161.被共済職員／経営主体別（２区分）・都道府県別・施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002154",
    label:
      "EXP1002154:【補助】162.被共済職員／都道府県別・施設種類別（施設・事業単位）",
    formKbn: "2",
  },
  {
    value: "EXP1002155",
    label:
      "EXP1002155:【補助】163.被共済職員／経営主体別（2 区分）・都道府県別・施設種類別（介護施設等）",
    formKbn: "2",
  },
  {
    value: "EXP1002156",
    label: "EXP1002156:1.職員数",
    formKbn: "2",
  },
  {
    value: "EXP1002157",
    label: "EXP1002157:４．１時点、全共済契約者",
    formKbn: "2",
  },
  {
    value: "EXP1002158",
    label: "EXP1002158:2.退職者数",
    formKbn: "2",
  },
  {
    value: "EXP1002159",
    label: "EXP1002159:3.脱退率",
    formKbn: "2",
  },
  {
    value: "EXP1002160",
    label: "EXP1002160:4.在籍期間分類率",
    formKbn: "2",
  },
  {
    value: "EXP1002161",
    label: "EXP1002161:5.請求率",
    formKbn: "2",
  },
  {
    value: "EXP1002162",
    label: "EXP1002162:6.計算基礎額",
    formKbn: "2",
  },
  {
    value: "EXP1002163",
    label: "EXP1002163:加入施設名簿",
    formKbn: "2",
  },
  {
    value: "EXP1002164",
    label: "EXP1002164:既契約入金状況",
    formKbn: "2",
  },
  {
    value: "EXP1002165",
    label: "EXP1002165:特定介護保険施設数",
    formKbn: "2",
  },
  {
    value: "EXP1002166",
    label: "EXP1002166:入金状況一覧表(確定時現在)",
    formKbn: "2",
  },
  {
    value: "EXP1002168",
    label: "EXP1002168:01.被共済職員数／施設種類別、年齢各歳別、在籍期間別",
    formKbn: "2",
  },
  {
    value: "EXP1002169",
    label:
      "EXP1002169:02.退職者数／施設種類別、年齢別（55 歳未満･55 歳以上）、在籍期間別、退職率①",
    formKbn: "2",
  },
  {
    value: "EXP1002170",
    label:
      "EXP1002170:03.退職者数／施設種類別、年齢別（5 歳刻み）、在籍期間別、退職率①",
    formKbn: "2",
  },
  {
    value: "EXP1002171",
    label:
      "EXP1002171:04.退職者数／施設種類別、年齢別（5 歳刻み）、在籍期間別、退職率②",
    formKbn: "2",
  },
  {
    value: "EXP1002172",
    label:
      "EXP1002172:05.退職者数／施設種類別、年齢別（55 歳未満・55 歳以上）、在籍期間別、在籍期間分類別（T）、退職者数①",
    formKbn: "2",
  },
  {
    value: "EXP1002173",
    label:
      "EXP1002173:06.退職者数／施設種類別、年齢別（55 歳未満・55 歳以上）、在籍期間別、在籍期間分類別（T+1）、退職者数①",
    formKbn: "2",
  },
  {
    value: "EXP1002174",
    label:
      "EXP1002174:07.退職者数／施設種類別、年齢別（5 歳刻み）、在籍期間別、在籍期間分類別（T）、退職者数①",
    formKbn: "2",
  },
  {
    value: "EXP1002175",
    label:
      "EXP1002175:08.退職者数／施設種類別、年齢別（5 歳刻み）、在籍期間別、在籍期間分類別（T+1）、退職者数①",
    formKbn: "2",
  },
  {
    value: "EXP1002176",
    label:
      "EXP1002176:09.退職者数／施設種類別、退職年度別、被共済職員期間別、支給者数",
    formKbn: "2",
  },
  {
    value: "EXP1002177",
    label: "EXP1002177:10.平均計算基礎額／在籍期間別、本俸階級別、被共済職員数",
    formKbn: "2",
  },
  {
    value: "EXP1002178",
    label:
      "EXP1002178:11.平均計算基礎額／施設種類別、年齢別（5 歳刻み）、在籍期間別、退職者平均本俸",
    formKbn: "2",
  },
  {
    value: "EXP1002179",
    label:
      "EXP1002179:12.平均計算基礎額／施設種類別、年齢別（5 歳刻み）、在籍期間別、被共済職員平均本俸",
    formKbn: "2",
  },
  {
    value: "EXP1002180",
    label:
      "EXP1002180:13.新規加入者数／施設種類別、年齢各歳別、当年４／１新規加入者数",
    formKbn: "2",
  },
  {
    value: "EXP1002181",
    label:
      "EXP1002181:14.新規加入者数／施設種類別、年齢各歳別、前年度４／２～当年４／１新規加入者数",
    formKbn: "2",
  },
  {
    value: "EXP1002182",
    label: "EXP1002182:15.支給乗率／退職理由別、支給者数",
    formKbn: "2",
  },
  {
    value: "EXP1002183",
    label: "EXP1002183:16.調整率／計算基礎額別、被共済職員期間別",
    formKbn: "2",
  },
  {
    value: "EXP1002184",
    label:
      "EXP1002184:17.経過規定適用者／被共済職員期間別、経過規定適用　支給件数・支給金額等",
    formKbn: "2",
  },
  {
    value: "EXP1002185",
    label: "EXP1002185:18.退職者数／施設種類別、年齢各歳別、在籍期間別",
    formKbn: "2",
  },
  {
    value: "EXP1002186",
    label:
      "EXP1002186:19.本俸総額／施設種類別、年齢各歳別、在籍期間別、退職者本俸総額",
    formKbn: "2",
  },
  {
    value: "EXP1002187",
    label: "EXP1002187:021.退職者数／施設種類別、在籍期間別、退職率①",
    formKbn: "2",
  },
  {
    value: "EXP1002189",
    label: "EXP1002189:確定職員（４．１在籍のみ）",
    formKbn: "2",
  },
];

// データダウンロード
const dataDownload = [
  {
    value: "EXP0304201",
    label: "EXP0304201:掛金届未提出者一覧",
    formKbn: "1",
  },
  {
    value: "EXP0404192",
    label: "EXP0404192:掛金過納・未納者リスト",
    formKbn: "1",
  },
  {
    value: "EXP0404194",
    label: "EXP0404194:過納金返還・割増金請求リスト",
    formKbn: "1",
  },
  {
    value: "EXP0404208",
    label: "EXP0404208:入金の出力データ",
    formKbn: "1",
  },
  {
    value: "EXP0602038",
    label:
      "EXP0602038:契約対象外施設等異動職員にかかる管理及び届出について（通知文差込データ用）",
    formKbn: "1",
  },
  {
    value: "EXP0604195",
    label: "EXP0604195:契約対象外施設等異動期限別リスト",
    formKbn: "1",
  },
  {
    value: "EXP0704043",
    label: "EXP0704043:退職年度別・支給状況リスト",
    formKbn: "1",
  },
  {
    value: "EXP0704205",
    label: "EXP0704205:時効該当者一覧表",
    formKbn: "1",
  },
  {
    value: "EXP0704206",
    label: "EXP0704206:時効該当予定者一覧表",
    formKbn: "1",
  },
  {
    value: "EXP0704209",
    label: "EXP0704209:退職手当金支給明細（平均処理日数算出）",
    formKbn: "1",
  },
  {
    value: "EXP0804210",
    label: "EXP0804210:預り金の時効対象者管理",
    formKbn: "1",
  },
  {
    value: "RPT0102029",
    label: "RPT0102029:既契約掛金振込用紙依頼書",
    formKbn: "1",
  },
  {
    value: "RPT0301009",
    label: "RPT0301009:掛金納付対象職員届",
    formKbn: "1",
  },
];

// 印刷データ出力
const printDataOutput = [
  {
    value: "EIF0300006",
    label: "EIF0300006:掛金届督促データ出力",
    formKbn: "",
  },
  {
    value: "EIF0300007",
    label: "EIF0300007:掛金納付お知らせデータ出力",
    formKbn: "",
  },
  {
    value: "EIF0300008",
    label: "EIF0300008:掛金納付督促データ出力",
    formKbn: "",
  },
  {
    value: "EIF0700009",
    label: "EIF0700009:退職手当金送金通知書（兼源泉徴収票）データ出力",
    formKbn: "",
  },
  {
    value: "EIF0700010",
    label: "EIF0700010:退職手当金再送金通知書データ出力",
    formKbn: "",
  },
  {
    value: "EIF0700013",
    label: "EIF0700013:退職手続き書類の提出確認データ出力",
    formKbn: "",
  },
  {
    value: "EIF0400014",
    label: "EIF0400014:過納金返還通知データ出力",
    formKbn: "",
  },
  {
    value: "EIF0700015",
    label: "EIF0700015:退職手当金支給決定状況報告データ出力",
    formKbn: "",
  },
  {
    value: "EIF1200016",
    label: "EIF1200016:宛名印刷",
    formKbn: "",
  },
];
export {
  headList,
  radioList,
  destinationRadioList,
  yearList,
  houjinnRadioList,
  yearOutput,
  definitiveStatisticalOutput,
  dataDownload,
  printDataOutput,
  selectStaus,
};
